import Reveal from "@/components/Reveal";

export const LEGAL_UPDATED = "29 September 2025";

export const LEGAL_CONTACT = {
  email: "connect@abhivesha.store",
  phone: "+91 70207 24570",
  gst: "27FWWPS0834K1ZM",
  fssai: "21526025003464",
  entity: "Abhivesha Trends",
  brand: "Abhivesha Foods",
  address: "06 Bashte Plaza, Udyam Nagar Road, Ratnagiri, Maharashtra 415612",
};

export default function LegalLayout({ title, eyebrow, intro, children }) {
  return (
    <div className="mx-auto max-w-3xl px-4 pb-24 pt-28 sm:px-6" data-testid="legal-page">
      <Reveal>
        <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-leaf">{eyebrow}</p>
        <h1 className="mt-2 font-display text-4xl font-extrabold tracking-tight text-forest sm:text-5xl">{title}</h1>
        <p className="mt-3 text-sm leading-relaxed text-ink/70">{intro}</p>
        <p className="mt-2 font-mono text-[11px] uppercase tracking-wider text-ink/40">Last updated: {LEGAL_UPDATED}</p>
      </Reveal>
      <Reveal delay={0.08}>
        <div className="mt-10 space-y-8">{children}</div>
      </Reveal>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section className="rounded-3xl border border-sand bg-white p-6 sm:p-8" data-testid="legal-section">
      <h2 className="font-display text-lg font-extrabold uppercase tracking-wide text-forest">{title}</h2>
      <div className="mt-4 space-y-3 text-sm leading-relaxed text-ink/75">{children}</div>
    </section>
  );
}
